import { Component, signal } from '@angular/core';
import { ErrorComponent, InputComponent } from '@group24ag/flowkit';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass, faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
  imports: [ErrorComponent, FormsModule, InputComponent, ReactiveFormsModule],
  selector: 'app-ui-inputs',
  template: `
    <div>
      <h1 class="heading-title">Inputs</h1>
      <div class="flex flex-col gap-10">
        <flk-input
          [(ngModel)]="value"
          [placeholder]="'Your name'"
          [label]="'Name'"
          class="w-96" />
        <flk-input
          [formControl]="control1"
          [placeholder]="'Your name'"
          [label]="'Name'"
          [prefixIcon]="['fas', 'magnifying-glass']"
          class="w-96" />
        <flk-input
          [formControl]="control2"
          [placeholder]="'Your name'"
          [label]="'Name'"
          class="w-96" />
        <flk-input
          [formControl]="control3"
          [placeholder]="'Your name'"
          [label]="'Name'"
          class="w-96"
          [suffixIcon]="['fas', 'user']">
          <flk-error>Name is required</flk-error>
        </flk-input>
        <flk-input
          [formControl]="control4"
          [placeholder]="'Your name'"
          class="w-96"
          [prefixIcon]="['fas', 'magnifying-glass']"
          [suffixIcon]="['fas', 'user']" />
        <flk-input
          label="Password"
          type="password"
          [formControl]="control5"
          class="w-96" />
      </div>
    </div>
  `,
})
export class UIInputsComponent {
  control1 = new FormControl('Marcelo');
  control2 = new FormControl({ value: 'Marcelo', disabled: true });
  control3 = new FormControl('', [Validators.required]);
  control4 = new FormControl('');
  control5 = new FormControl('Password1234');

  value = 'Marcelo';
  disabled = signal(false);

  constructor(lib: FaIconLibrary) {
    lib.addIcons(faUser, faMagnifyingGlass);
  }
}
